import { useEffect, useState } from "react";

export default function DeChecks ({
    row: { index, original },
    states,
    registerStateChange

}) {
    const [value, setValue] = useState(false);
    const auth = sessionStorage.getItem('token');
    const onChange = event => {
        setValue(event.target.checked);
        registerStateChange(index, event.target.checked);
    }

    useEffect(() => {
        setValue(states[original.id] || states[original.bhfsdatId] || states[original.absDatId] || states[original.vvd_id]); 
      }, [states, original.id, original.bhfsdatId, original.absDatId, original.vvd_id])

    if (auth.includes('level2')) {
        return <input type="checkbox" onChange={onChange} checked={value}/>
    } else if (auth.includes('level1')) {
        switch (original.statusId) {
            case 8:
                return <input className="input-disabled" type="checkbox" disabled={true} onChange={onChange} checked={false}/>
            default:
                return <input type="checkbox" onChange={onChange} checked={value}/>
        }
    } else {
        switch (original.statusId) {
            case 5:
                return <input type="checkbox" onChange={onChange} checked={value}/>
            case 6:
                return <input type="checkbox" onChange={onChange} checked={value}/>
            default:
                return <input className="input-disabled" type="checkbox" disabled={true} onChange={onChange} checked={false}/>
        }
    }
}